(function () {
  'use strict';

  // ── Watch face SVG generators ──────────────────────────────
  function coord(cx, cy, r, deg) {
    var rad = (deg - 90) * Math.PI / 180;
    return { x: cx + r * Math.cos(rad), y: cy + r * Math.sin(rad) };
  }
  function getTime() {
    var n = new Date();
    return { h: n.getHours() % 12, m: n.getMinutes(), s: n.getSeconds() };
  }

  var W = {
    // Simbolo del logo WATCHELLO (lancette staccate dal centro), animato:
    // le lancette ruotano attorno al centro come un orologio (minuti veloce, ore lento),
    // partendo dalla posa del logo. Coordinate dal simbolo ufficiale.
    minimal: function (h, m, s) {
      return '<style>'
           + '.wt-mm-h,.wt-mm-m{transform-box:view-box;transform-origin:100px 100px;}'
           + '.wt-mm-m{animation:wt-mm-spin 40s linear infinite;}'
           + '.wt-mm-h{animation:wt-mm-spin 480s linear infinite;}'
           + '@keyframes wt-mm-spin{to{transform:rotate(360deg);}}'
           + '@media (prefers-reduced-motion:reduce){.wt-mm-h,.wt-mm-m{animation:none;}}'
           + '</style>'
           + '<circle cx="100" cy="100" r="88.0" fill="none" stroke="#F6F2EE" stroke-width="8.28"/>'
           + '<g class="wt-mm-h"><line x1="92.39" y1="95.6" x2="61.91" y2="78.0" stroke="#F6F2EE" stroke-width="9.15" stroke-linecap="butt"/></g>'
           + '<g class="wt-mm-m"><line x1="107.64" y1="95.6" x2="162.5" y2="63.92" stroke="#C47231" stroke-width="5.02" stroke-linecap="butt"/></g>';
    },
    dress: function (h, m, s) {
      var hP = coord(100,100,42,h*30+m*0.5), mP = coord(100,100,60,m*6),
          sP = coord(100,100,66,s*6), sR = coord(100,100,-16,s*6);
      var ticks = Array.from({length:12},function(_,i){
        var a=i*30, p1=coord(100,100,68,a), p2=coord(100,100,i%3===0?60:64,a);
        return '<line x1="'+p1.x+'" y1="'+p1.y+'" x2="'+p2.x+'" y2="'+p2.y+'" stroke="'+(i%3===0?'#C47231':'#4a4030')+'" stroke-width="'+(i%3===0?1.5:0.7)+'"/>';
      }).join('');
      return '<circle cx="100" cy="100" r="90" fill="#0F0D08" stroke="#C47231" stroke-width="1"/>'
           + '<circle cx="100" cy="100" r="82" fill="#0A0804"/>'
           + ticks
           + '<text x="100" y="76" text-anchor="middle" font-family="Montserrat,sans-serif" font-size="6" fill="#C47231" letter-spacing="2">WATCHELLO</text>'
           + '<line x1="100" y1="100" x2="'+hP.x+'" y2="'+hP.y+'" stroke="#E8D0A0" stroke-width="2" stroke-linecap="round"/>'
           + '<line x1="100" y1="100" x2="'+mP.x+'" y2="'+mP.y+'" stroke="#E8D0A0" stroke-width="1.3" stroke-linecap="round"/>'
           + '<line x1="'+sR.x+'" y1="'+sR.y+'" x2="'+sP.x+'" y2="'+sP.y+'" stroke="#C47231" stroke-width="0.8"/>'
           + '<circle cx="100" cy="100" r="2.5" fill="#C47231"/>';
    },
    sport: function (h, m, s) {
      var hP = coord(100,100,46,h*30+m*0.5), mP = coord(100,100,64,m*6),
          sP = coord(100,100,70,s*6), sR = coord(100,100,-16,s*6);
      var markers = Array.from({length:12},function(_,i){
        var a=i*30, c=coord(100,100,66,a), w=i%3===0?12:7;
        return '<rect x="'+(c.x-w/2)+'" y="'+(c.y-2.5)+'" width="'+w+'" height="5" fill="'+(i%3===0?'#C47231':'#888')+'" rx="1" transform="rotate('+a+','+c.x+','+c.y+')"/>';
      }).join('');
      return '<circle cx="100" cy="100" r="92" fill="#0E0E0E" stroke="#222" stroke-width="1"/>'
           + '<circle cx="100" cy="100" r="80" fill="#0A0A0A" stroke="#1E1E1E" stroke-width="1.5"/>'
           + markers
           + '<polygon points="100,28 94,40 106,40" fill="#C47231"/>'
           + '<text x="100" y="82" text-anchor="middle" font-family="Montserrat,sans-serif" font-size="6" fill="#D0D0D0" letter-spacing="1.5">WATCHELLO</text>'
           + '<line x1="100" y1="100" x2="'+hP.x+'" y2="'+hP.y+'" stroke="#F0F0F0" stroke-width="5" stroke-linecap="round"/>'
           + '<line x1="100" y1="100" x2="'+mP.x+'" y2="'+mP.y+'" stroke="#F0F0F0" stroke-width="3" stroke-linecap="round"/>'
           + '<line x1="'+sR.x+'" y1="'+sR.y+'" x2="'+sP.x+'" y2="'+sP.y+'" stroke="#C47231" stroke-width="1" stroke-linecap="round"/>'
           + '<circle cx="100" cy="100" r="4" fill="#111" stroke="#C47231" stroke-width="1.2"/>'
           + '<circle cx="100" cy="100" r="2" fill="#C47231"/>';
    },
    diver: function (h, m, s) {
      var hP = coord(100,100,44,h*30+m*0.5), mP = coord(100,100,62,m*6),
          sP = coord(100,100,68,s*6), sR = coord(100,100,-18,s*6);
      var bezel = Array.from({length:60},function(_,i){
        var a=i*6, p1=coord(100,100,93,a), p2=coord(100,100,i%5===0?86:90,a);
        return '<line x1="'+p1.x+'" y1="'+p1.y+'" x2="'+p2.x+'" y2="'+p2.y+'" stroke="'+(i%5===0?'#C47231':'#333')+'" stroke-width="'+(i%5===0?1.8:0.7)+'"/>';
      }).join('');
      var mrk = Array.from({length:12},function(_,i){
        var a=i*30, c=coord(100,100,64,a), w=i%3===0?12:7;
        return '<rect x="'+(c.x-w/2)+'" y="'+(c.y-2.5)+'" width="'+w+'" height="5" fill="'+(i%3===0?'#C47231':'#888')+'" rx="0.5" transform="rotate('+a+','+c.x+','+c.y+')"/>';
      }).join('');
      return '<circle cx="100" cy="100" r="95" fill="#0C0C0C" stroke="#222" stroke-width="1"/>'
           + bezel
           + '<circle cx="100" cy="100" r="80" fill="#0A0A09" stroke="#1E1E1E" stroke-width="1.5"/>'
           + mrk
           + '<text x="100" y="82" text-anchor="middle" font-family="Montserrat,sans-serif" font-size="5.5" fill="#C0C0C0" letter-spacing="1.5">WATCHELLO</text>'
           + '<text x="100" y="90" text-anchor="middle" font-family="Montserrat,sans-serif" font-size="4.5" fill="#666" letter-spacing="1.5">DIVER 200m</text>'
           + '<line x1="100" y1="100" x2="'+hP.x+'" y2="'+hP.y+'" stroke="#EEEEEE" stroke-width="5" stroke-linecap="round"/>'
           + '<line x1="100" y1="100" x2="'+mP.x+'" y2="'+mP.y+'" stroke="#EEEEEE" stroke-width="3" stroke-linecap="round"/>'
           + '<line x1="'+sR.x+'" y1="'+sR.y+'" x2="'+sP.x+'" y2="'+sP.y+'" stroke="#C47231" stroke-width="1"/>'
           + '<circle cx="100" cy="100" r="3.5" fill="#111" stroke="#C47231" stroke-width="1.2"/>';
    },
    classic: function (h, m, s) {
      var hP = coord(100,100,42,h*30+m*0.5), mP = coord(100,100,60,m*6),
          sP = coord(100,100,66,s*6), sR = coord(100,100,-14,s*6);
      var hticks = Array.from({length:12},function(_,i){
        var a=i*30, p1=coord(100,100,70,a), p2=coord(100,100,i%3===0?62:66,a);
        return '<line x1="'+p1.x+'" y1="'+p1.y+'" x2="'+p2.x+'" y2="'+p2.y+'" stroke="#C8A060" stroke-width="'+(i%3===0?1.5:0.9)+'"/>';
      }).join('');
      return '<circle cx="100" cy="100" r="88" fill="#12100A" stroke="#C8A060" stroke-width="1.2"/>'
           + '<circle cx="100" cy="100" r="80" fill="#0C0A06"/>'
           + hticks
           + '<text x="100" y="78" text-anchor="middle" font-family="Montserrat,sans-serif" font-size="6" fill="#C8A060" letter-spacing="2">WATCHELLO</text>'
           + '<line x1="100" y1="100" x2="'+hP.x+'" y2="'+hP.y+'" stroke="#D4B060" stroke-width="2.2" stroke-linecap="round"/>'
           + '<line x1="100" y1="100" x2="'+mP.x+'" y2="'+mP.y+'" stroke="#D4B060" stroke-width="1.4" stroke-linecap="round"/>'
           + '<line x1="'+sR.x+'" y1="'+sR.y+'" x2="'+sP.x+'" y2="'+sP.y+'" stroke="#C47231" stroke-width="0.7"/>'
           + '<circle cx="100" cy="100" r="2.5" fill="#C8A060"/>';
    },
    orient:  function (h, m, s) { return W.classic(h, m, s); },
    citizen: function (h, m, s) { return W.dress(h, m, s); },
    casio:   function (h, m, s) { return W.sport(h, m, s); },
    versace: function (h, m, s) {
      var hP = coord(100,100,42,h*30+m*0.5), mP = coord(100,100,60,m*6),
          sP = coord(100,100,66,s*6), sR = coord(100,100,-14,s*6);
      var ticks = Array.from({length:12},function(_,i){
        var a=i*30, p1=coord(100,100,70,a), p2=coord(100,100,i%3===0?62:66,a);
        return '<line x1="'+p1.x+'" y1="'+p1.y+'" x2="'+p2.x+'" y2="'+p2.y+'" stroke="#D4AF50" stroke-width="'+(i%3===0?2:1)+'"/>';
      }).join('');
      return '<circle cx="100" cy="100" r="90" fill="#100F0D" stroke="#D4AF50" stroke-width="2"/>'
           + '<circle cx="100" cy="100" r="78" fill="#0C0B09"/>'
           + ticks
           + '<text x="100" y="76" text-anchor="middle" font-family="Montserrat,sans-serif" font-size="7" fill="#D4AF50" letter-spacing="1.5">VERSACE</text>'
           + '<line x1="100" y1="100" x2="'+hP.x+'" y2="'+hP.y+'" stroke="#D4AF50" stroke-width="2.5" stroke-linecap="round"/>'
           + '<line x1="100" y1="100" x2="'+mP.x+'" y2="'+mP.y+'" stroke="#D4AF50" stroke-width="1.5" stroke-linecap="round"/>'
           + '<line x1="'+sR.x+'" y1="'+sR.y+'" x2="'+sP.x+'" y2="'+sP.y+'" stroke="#C47231" stroke-width="0.8"/>'
           + '<circle cx="100" cy="100" r="3" fill="#D4AF50"/>';
    },
    invicta: function (h, m, s) { return W.diver(h, m, s); },
    lorus:   function (h, m, s) { return W.sport(h, m, s); },
    nautica: function (h, m, s) { return W.diver(h, m, s); },
  };
  // Aliases for handles that differ from base name
  W['just-cavalli-watches']                        = W.versace;
  W['roberto-cavalli-watches']                     = W.versace;
  W['roberto-cavalli-by-franck-muller-watches']    = W.classic;
  W['orient-watches']                              = W.classic;
  W['citizen-watches']                             = W.dress;
  W['casio-watches']                               = W.sport;
  W['versace-watches']                             = W.versace;
  W['dkny-watches']                                = W.sport;
  W['invicta-watches']                             = W.diver;
  W['lorus-watches']                               = W.sport;
  W['nautica-watches']                             = W.diver;
  // Watch style aliases
  W['dresswatches']   = W.dress;
  W['diver&sport']    = W.diver;
  W['diverwatches']   = W.diver;
  W['divers&sport']   = W.diver;
  W['sport&dive']     = W.diver;
  W['casualwatches']  = W.sport;
  W['classicwatches'] = W.classic;
  W['militarywatches']= W.sport;

  function renderSvg(svgEl, face) {
    // Stile uniforme: usa sempre il quadrante minimale del logo per tutti i brand/categorie
    var t = getTime();
    svgEl.innerHTML = W.minimal(t.h, t.m, t.s);
  }

  // ── Init after DOM ready ───────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    var mega    = document.getElementById('wm-mega');
    var overlay = document.getElementById('wm-overlay');
    if (!mega || !overlay) return;

    // Collect all panels — indexed by English type AND locale-specific nav text
    var panels = {};
    mega.querySelectorAll('.wm-panel').forEach(function (p) {
      if (p.dataset.title)   panels[p.dataset.title]   = p; // always English: "watches"
      if (p.dataset.navText) panels[p.dataset.navText] = p; // locale text: "orologi"
    });

    // Start SVG clocks — render all visible panels' SVGs every second
    var activeFaces = {}; // panelTitle -> current face string

    // Render una sola volta: il movimento è gestito dall'animazione CSS (no re-render al secondo)
    function renderAllSvgs() {
      mega.querySelectorAll('[data-watch-svg]').forEach(function (svg) {
        var face = svg.dataset.currentFace || svg.dataset.defaultFace || 'orient';
        renderSvg(svg, face);
      });
    }
    renderAllSvgs();

    // ── Hook into Symmetry theme nav ──
    var openPanel = null;

    function openMega(panelTitle, navLi) {
      if (openPanel === panelTitle) { closeMega(); return; }

      // Close any open
      Object.values(panels).forEach(function (p) { p.classList.remove('is-open'); });
      document.querySelectorAll('.navigation__item[data-wm]').forEach(function (li) {
        li.classList.remove('navigation__item--active');
      });

      var panel = panels[panelTitle];
      if (!panel) return;

      panel.classList.add('is-open');
      if (navLi) navLi.classList.add('navigation__item--active');
      mega.setAttribute('aria-hidden', 'false');
      overlay.classList.add('is-open');
      openPanel = panelTitle;

      // Render the panel's SVG immediately on open
      var svg = panel.querySelector('[data-watch-svg]');
      if (svg) renderSvg(svg, svg.dataset.currentFace || svg.dataset.defaultFace || 'orient');
    }

    function closeMega() {
      Object.values(panels).forEach(function (p) { p.classList.remove('is-open'); });
      document.querySelectorAll('.navigation__item[data-wm]').forEach(function (li) {
        li.classList.remove('navigation__item--active');
      });
      mega.setAttribute('aria-hidden', 'true');
      overlay.classList.remove('is-open');
      openPanel = null;
    }

    // ── Hook directly into #proxy-nav (Symmetry's desktop nav) ──
    var leaveTimer = null;

    function scheduleClose() {
      leaveTimer = setTimeout(closeMega, 150);
    }
    function cancelClose() {
      clearTimeout(leaveTimer);
    }

    var proxyNav = document.getElementById('proxy-nav');
    if (proxyNav) {
      proxyNav.querySelectorAll('.navigation__item').forEach(function (li) {
        var link = li.querySelector('.navigation__link');
        if (!link) return;
        var title = link.textContent.trim().toLowerCase();
        if (!panels[title]) return;

        li.setAttribute('data-wm', title);

        // Open on hover — same event Symmetry uses, ours fires first
        li.addEventListener('mouseenter', function () {
          cancelClose();
          openMega(title, li);
        });
        li.addEventListener('mouseleave', scheduleClose);

        // Prevent click navigation (capture phase = before Symmetry's handlers)
        link.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          openMega(title, li);
        }, true);
      });
    }

    // Keep mega open while cursor is inside it
    mega.addEventListener('mouseenter', cancelClose);
    mega.addEventListener('mouseleave', scheduleClose);

    overlay.addEventListener('click', closeMega);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMega(); });

    // Close when clicking outside
    document.addEventListener('click', function (e) {
      if (openPanel && !mega.contains(e.target) && !e.target.closest('[data-wm]')) {
        closeMega();
      }
    });

    // ── Brand hover → swap SVG in Brands panel ──
    var brandsPanel = panels['brands'];
    if (brandsPanel) {
      var bpSvg = brandsPanel.querySelector('[data-watch-svg]');
      var bpTitle = brandsPanel.querySelector('.wm-preview-title');

      brandsPanel.querySelectorAll('.wm-brand-card[data-preview]').forEach(function (card) {
        card.addEventListener('mouseenter', function () {
          var face = card.dataset.preview;
          var name = card.querySelector('.wm-brand-name').textContent;
          if (bpSvg) {
            bpSvg.dataset.currentFace = face;
            bpSvg.style.opacity = '0';
            bpSvg.style.transform = 'scale(0.94)';
            bpSvg.style.transition = 'opacity 0.2s, transform 0.2s';
            setTimeout(function () {
              renderSvg(bpSvg, face);
              bpSvg.style.opacity = '1';
              bpSvg.style.transform = 'scale(1)';
            }, 100);
          }
          if (bpTitle) bpTitle.textContent = name;
        });
      });
    }

    // ── Style category hover → swap SVG in Watches panel ──
    var watchesPanel = panels['watches'];
    if (watchesPanel) {
      var wcSvg   = watchesPanel.querySelector('[data-watch-svg]');
      var wcTitle = watchesPanel.querySelector('.wm-preview-title');

      watchesPanel.querySelectorAll('.wm-list-lg-item[data-watch]').forEach(function (item) {
        item.addEventListener('mouseenter', function () {
          watchesPanel.querySelectorAll('.wm-list-lg-item').forEach(function (i) { i.classList.remove('active'); });
          item.classList.add('active');
          var face = item.dataset.watch;
          if (wcSvg) {
            wcSvg.dataset.currentFace = face;
            wcSvg.style.opacity = '0';
            wcSvg.style.transform = 'scale(0.94)';
            wcSvg.style.transition = 'opacity 0.22s, transform 0.22s';
            setTimeout(function () {
              renderSvg(wcSvg, face);
              wcSvg.style.opacity = '1';
              wcSvg.style.transform = 'scale(1)';
            }, 110);
          }
          if (wcTitle) wcTitle.textContent = item.textContent.trim(); // testo tradotto dal menu
        });
      });
    }
  });

})();
